import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteServices } from "../../api/apiServices";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي نهائي للخدمات
 */
export function useForceDeleteAllServices() {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllServicesMutate,
        isPending,
    } = useMutation({
        mutationFn: massForceDeleteServices,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete services");
        },
    });

    return {
        forceDeleteAllServicesMutate,
        isPending,
    };
}